import React from 'react';
import { Droppable } from '@hello-pangea/dnd';

/**
 * Componente para renderizar uma lista que pode receber itens arrastáveis
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.droppableId - ID único da área dropável
 * @param {string} props.type - Tipo de itens que esta área aceita (ex: 'service', 'category')
 * @param {React.ReactNode} props.children - Itens arrastáveis dentro desta área
 * @param {string} props.className - Classes CSS adicionais 
 */
const DroppableList = ({ droppableId, type, children, className = '' }) => {
  return (
    <Droppable droppableId={droppableId} type={type}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={`
            py-1.5 px-1.5 rounded-lg select-none
            ${snapshot.isDraggingOver ? 'bg-blue-50 border border-blue-100' : 'bg-gray-50 border border-gray-100'}
            transition-all duration-200 ease-in-out
            ${className}
          `}
          data-droppable-id={droppableId}
          data-droppable-type={type}
          style={{
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            touchAction: 'manipulation'
          }}
        >
          <div className="space-y-1.5">
            {children}
          </div>
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default DroppableList; 